import React from "react";
import { useMediaQuery } from "react-responsive";
import TableLoader from "../../commanPage/loader/TableLoader";
import { convertTo12HourFormat, NoItemsLeftInTable } from "../../../helper/helpers";

function LotTimeExtentionTable({
  offers,
  singleAuctionLoading,
  selectedOffers,
  setSelectedOffers,
}) {
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });

  // Handle select/deselect individual offer
  const handleSelectOffer = (offerId) => {
    if (selectedOffers?.some((obj) => obj.offerId === offerId && obj.checkedOffer === true)) {
      setSelectedOffers((prev) =>
        prev?.map((offer) => offer?.offerId !== offerId ? offer : { ...offer, checkedOffer: false })
      );
    } else {
      setSelectedOffers((prev) => prev?.map((offers) => offerId !== offers.offerId ? offers : { ...offers, checkedOffer: true }));
    }
  };


  if (singleAuctionLoading) {
    return (
      <TableLoader
        headerData={[
          "Lots Id",
          "Product Type",
          "Quantity / UOM",
          "Min Increment(Rs.)",
          "Action",
        ]}
      />
    );
  }
  return (
    <div className={`${!isTablet && "table-container-style"} mb-1 full-width`}>
      <table
        className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
          } `}
      >
        <thead>
          <tr>
            <th>
              #
            </th>

            <th>Lots No.</th>
            <th>Product Type</th>
            <th>End Time</th>
            <th>Updated Time By</th>
          </tr>
        </thead>
        <tbody>
          {offers?.map((items) => (
            <tr key={items?.fullOfferDetails?._id}>
              <td style={{ width: "100px" }}>
                <span
                  className="material-symbols-outlined pointer"
                  onClick={() => handleSelectOffer(items?.fullOfferDetails?._id)}
                  style={{ cursor: "pointer" }}
                >
                  {selectedOffers?.some((obj) => obj.offerId === items?.fullOfferDetails?._id && obj.checkedOffer === true)
                    ? "check_box"
                    : "check_box_outline_blank"}
                </span>
              </td>

              <td>{items?.fullOfferDetails?.offerNumber}</td>
              <td style={{ width: !isTablet && "230px" }}>
                <span className="NoOfline" style={{ WebkitLineClamp: 1 }}>
                  {items?.fullOfferDetails?.scrapDetails?.type}
                </span>
              </td>
             <td>{convertTo12HourFormat(items?.fullOfferDetails?.offerSchedule?.endTimeAndDate)}</td>
              <td>
                <input
                  type="time"
                  placeholder="Time Table"
                  value={selectedOffers?.find((obj) => obj.offerId === items?.fullOfferDetails?._id)?.extendMinutes || "00:00"}
                  className="input-table"
                  disabled={!selectedOffers?.some((obj) => obj.offerId === items?.fullOfferDetails?._id && obj.checkedOffer === true)}
                  key={items._id}
                  onChange={(e) => {
                    const newTime = e.target.value;
                    setSelectedOffers((prev) =>
                      prev?.map((offer) =>
                        offer?.offerId !== items?.fullOfferDetails?._id
                          ? offer
                          : { ...offer, extendMinutes: newTime }
                      )
                    );
                  }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {offers?.length === 0 && <NoItemsLeftInTable />}
    </div>
  );
}

export default LotTimeExtentionTable;
